module.exports = __webpack_public_path__ + "static/media/05.0b5c54f2.webp";